import InventoryControlDriversTabComponent from './InventoryControlDriversTab';

const InventoryControlDriversTab = InventoryControlDriversTabComponent;

export default InventoryControlDriversTab;
